// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

const SharedComponent = ({ sharedComponentContent: { useContainer, content } }) => {
  const components = (content || []).map((component) => (
    <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
  ));

  return (
    <>{useContainer ? <div className="mx-auto w-[90vw] xl:w-(--container-width)">{components}</div> : components}</>
  );
};
export default SharedComponent;
